import styled from 'styled-components';

export const FooterContent = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const WaitingContainer = styled.div`
    display: 'flex';
    align-items: center;
    align-content: center;
    justify-content: center;
`;